import { Injectable } from '@angular/core';

import { ApiService } from '../core/upgraded-providers';

@Injectable({
    providedIn: 'root'
})
export class CreepsService {
    constructor(
        private _apiService: ApiService
    ) {
    }

    read(): angular.IPromise<{ list: [] }> {
        return this._apiService
            .get('game/power-creeps/list', { });
    }

    create(data) {
        return this._apiService
            .post('game/power-creeps/create', data);
    }

    upgrade(data) {
        return this._apiService
            .post('game/power-creeps/upgrade', data);
    }

    rename(data) {
        return this._apiService
            .post('game/power-creeps/rename', data);
    }

    delete(params) {
        return this._apiService
            .post('game/power-creeps/delete', params);
    }

    cancelDeletion(params) {
        return this._apiService
            .post('game/power-creeps/cancel-delete', params);
    }

    promo() {
        return this._apiService
            .post('game/power-creeps/promo', {});
    }

    activatePowerExperimentation() {
        return this._apiService
            .post('game/power-creeps/experimentation', {});
    }
}
